/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTermsResource } from './';
import {
    ClientTermsResourceFromJSON,
    ClientTermsResourceFromJSONTyped,
    ClientTermsResourceToJSON,
} from './';
import type { ContractInvoicingModeResource } from './';
import {
    ContractInvoicingModeResourceFromJSON,
    ContractInvoicingModeResourceFromJSONTyped,
    ContractInvoicingModeResourceToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractSubcontractingModeResource
 */
export interface ContractSubcontractingModeResource extends ContractInvoicingModeResource {
    /**
     * 
     * @type {ClientTermsResource}
     * @memberof ContractSubcontractingModeResource
     */
    clientTerms?: ClientTermsResource;
}

/**
 * Check if a given object implements the ContractSubcontractingModeResource interface.
 */
export function instanceOfContractSubcontractingModeResource(value: object): value is ContractSubcontractingModeResource {
    return true;
}

export function ContractSubcontractingModeResourceFromJSON(json: any): ContractSubcontractingModeResource {
    return ContractSubcontractingModeResourceFromJSONTyped(json, false);
}

export function ContractSubcontractingModeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractSubcontractingModeResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ContractInvoicingModeResourceFromJSONTyped(json, ignoreDiscriminator),
        'clientTerms': json['clientTerms'] == null ? undefined : ClientTermsResourceFromJSON(json['clientTerms']),
    };
}

export function ContractSubcontractingModeResourceToJSON(value?: ContractSubcontractingModeResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ContractInvoicingModeResourceToJSON(value, true),
        'clientTerms': ClientTermsResourceToJSON(value['clientTerms']),
    };
}

